<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <h2 class="m-0">{{'GENERICSURVEY.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8">
            <span>{{'GENERICSURVEY.SUBTITULO' | translate}}</span>
          </div>
          <!-- / CONTENT TOOLBAR -->
          <div class="changelog w100 p-20" fxFlex fxLayout="column" fxLayoutAlign="start center">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-around stretch">
            <mat-form-field appearance="outline" class="w100">
              <mat-label>{{'GENERICSURVEY.CAMPOS.Token' | translate}}</mat-label>
              <input matInput placeholder="{{'GENERICSURVEY.CAMPOS.Token' | translate}}" [(ngModel)]="tokenConfig" (keyup)="consultSurveyGeneric()">
              <mat-icon matSuffix>list_alt</mat-icon>
            </mat-form-field>
            </div>

            <ng-container *ngIf="busquedaIniciada">
              <div fxLayout="column" fxLayoutAlign="start center" class="p-20" *ngIf="buscando == true" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <p>{{'GENERICSURVEY.RESULTADOS.CARGANDO' | translate}}</p>
                <div class="spinnerCGO"></div>
              </div>
              <div *ngIf="buscando == false" fxLayout="column" fxLayoutAlign="start center" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <h1>{{'GENERICSURVEY.RESULTADOS.TITULO' | translate}}</h1>
                <ng-container *ngIf="reportSurveyGeneric.length > 0; else sinResultados">
                  <h2>{{'GENERICSURVEY.RESULTADOS.ENCONTRADAS' | translate}}<b>{{reportSurveyGeneric.length}}</b></h2>
                  <button mat-raised-button color="primary" (click)="descargarResultados()">{{'GENERICSURVEY.RESULTADOS.DESCARGAR' | translate}}</button>
                </ng-container>
                <ng-template #sinResultados>
                  <h2><em>{{'GENERICSURVEY.RESULTADOS.SINRESULTADOS' | translate}}</em></h2>
                </ng-template>
              </div>
            </ng-container>

          </div>

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
